var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 777.644,
    height: 752.431,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(569 -313)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M-335.159 1047.161c-241.826-167.38-416.86-531.286 109.468-721.67 37.326-13.5 145.407-20.625 177.432 2.825 119.344 87.388 245.115 163.008 255.654 241.665 13.141 98.075-81.405 19.871-93.263 48.395-4.808 11.858 16.345 8.974 30.126 24.677s3.2 42.625-41.024 49.036-24.677 68.586 26.28 97.43-4.808 129.155-142.3 136.527c-52.766 2.829-88.3 30.107-112.061 62.654-45.597 62.452-128.738 96.281-199.338 64.743a91.154 91.154 0 01-10.974-6.282z",
    fill: "#5300f2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M177.447 668.294c9.22-3.341 10.709 4.794 10.709 10.709a10.709 10.709 0 01-10.709 10.709c-5.914 0-10.444-1.229-10.444-7.144s1.225-10.934 10.444-14.274z",
    fill: "#5300f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M165.428 656.859c1.893 0 4.646 3.264 4.646 5.157s-2.753 1.7-4.647 1.7a3.429 3.429 0 01.001-6.857z",
    fill: "#5300f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M190.046 650.315c0 2.582-1.542 3.441-4.674 4.674-3.653 1.269-6.819 7.042-9.612 0a21.962 21.962 0 01-1.676-9.531c.559-5.216 15.962 2.276 15.962 4.857z",
    fill: "#5300f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 17",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(196 666)",
    fill: "#5300f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(193 672)",
    fill: "#5300f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 109",
    d: "M25.694 889.541s46.086-7.146 64.137-22.713",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.99883
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110",
    d: "M101.34 859.248a73.388 73.388 0 0012.72-12.462",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.0013500000000004
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 33",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(94 862)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble1);
export default __webpack_public_path__ + "static/media/bubble1.0535043ef8936c35354b9670c90289b4.svg";
export { ForwardRef as ReactComponent };